import React from 'react';
import Form from "react-bootstrap/Form";
import Cert2CheckItems from "./Cert2CheckItems";

const CertificationInfo2FormV2 = ({fields, handleFieldChange,
                                cert2Checks, handleCert2ChecksChange,
                                cert2ChecksMessage,
                                messages, page, isEdit}) => {

  const handleChecks = (e) => {
    console.log(e.target.checked);
    const i = e.target.id.substring('cert2Checks'.length);
    console.log(i);
    if (!e.target.checked) {
      let elmt = document.getElementById('certifiedNo' + i + 'Message');
      elmt.textContent = '';
      elmt = document.getElementById('certifiedDate' + i + 'Message');
      elmt.textContent = '';
      messages['certifiedNo' + i].n = '';
      messages['certifiedDate' + i].n = '';
    }
    handleCert2ChecksChange(e);
  };

  return (
    <>
      <h3>資格</h3>
      <dl>
        <dt className="hiddenRow">取得資格番号<span className="red">*</span></dt>
        <dd className="hiddenRow">
          <Form.Group className="inlineFormControl" controlId="certificationNumber" size="lg">
            <Form.Control
              type="text"
              name="certificationNumber"
              value={fields.certificationNumber}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="certificationNumberMessage" className="errorMessages">{messages.certificationNumber.n}</p>
        </dd>

        <dt className="hiddenRow">取得年月日<span className="red">*</span></dt>
        <dd className="hiddenRow">
          <Form.Group controlId="acquiredDate" size="lg">
            <Form.Control
              type="text"
              name="acquiredDate"
              value={fields.acquiredDate}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>例：2021/01/01</p>
          <p id="acquiredDateMessage" className="errorMessages">{messages.acquiredDate.n}</p>
       </dd>

        <dt>資格・身分<span className="red">*</span></dt>
        <dd className="shikaku_jyunmember">
          <p className="text_note">チェックした資格の認定資格番号と取得年月日（例：2020/01/01 ）を記載ください。</p>
          <Form.Group size="lg">
          { Cert2CheckItems.map(({label, idx}, index) => (
            <>
            <Form.Check
              custom
              id={ "cert2Checks"+idx }
              name={ "cert2Checks"+idx }
              label={label}
              type="checkbox"
              value={parseInt(idx)+1}
              checked={ (parseInt(idx)+1) == cert2Checks[idx] }
              onChange={handleChecks}
            />
		  { idx == 11 ? <></> : <>
            <Form.Control
              type="text"
              id={"certifiedNo"+idx}
              name={"certifiedNo"+idx}
              value={fields["certifiedNo"+idx]}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id={"certifiedDate"+idx}
              name={"certifiedDate"+idx}
              value={fields["certifiedDate"+idx]}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
		    </> }
		  { idx == 11 ? <></> : <>
            <p id={"certifiedNo"+idx+"Message"} className="errorMessages">{messages["certifiedNo"+idx]["n"]}</p>
            <p id={"certifiedDate"+idx+"Message"} className="errorMessages">{messages["certifiedDate"+idx]["n"]}</p>
		    </> }
            </>
	  ))}
      {/*
            <Form.Check
              custom
              id="cert2Checks0"
              name="cert2Checks0"
              label="理学療法士"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[0] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo0"
              name="certifiedNo0"
              value={fields.certifiedNo0}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate0"
              name="certifiedDate0"
              value={fields.certifiedDate0}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo0Message" className="errorMessages">{messages.certifiedNo0.n}</p>
            <p id="certifiedDate0Message" className="errorMessages">{messages.certifiedDate0.n}</p>
            <Form.Check
              custom
              label="看護師"
              id="cert2Checks1"
              name="cert2Checks1"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[1] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo1"
              name="certifiedNo1"
              value={fields.certifiedNo1}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate1"
              name="certifiedDate1"
              value={fields.certifiedDate1}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo1Message" className="errorMessages">{messages.certifiedNo1.n}</p>
            <p id="certifiedDate1Message" className="errorMessages">{messages.certifiedDate1.n}</p>
            <Form.Check
              custom
              label="日本体育協会アスレチックトレーナー"
              id="cert2Checks2"
              name="cert2Checks2"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[2] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo2"
              name="certifiedNo2"
              value={fields.certifiedNo2}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate2"
              name="certifiedDate2"
              value={fields.certifiedDate2}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo2Message" className="errorMessages">{messages.certifiedNo2.n}</p>
            <p id="certifiedDate2Message" className="errorMessages">{messages.certifiedDate2.n}</p>
            <Form.Check
              custom
              label="薬剤師"
              id="cert2Checks3"
              name="cert2Checks3"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[3] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo3"
              name="certifiedNo3"
              value={fields.certifiedNo3}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate3"
              name="certifiedDate3"
              value={fields.certifiedDate3}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo3Message" className="errorMessages">{messages.certifiedNo3.n}</p>
            <p id="certifiedDate3Message" className="errorMessages">{messages.certifiedDate3.n}</p>
            <Form.Check
              custom
              label="JADA　公認スポーツファーマシスト"
              id="cert2Checks4"
              name="cert2Checks4"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[4] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo4"
              name="certifiedNo4"
              value={fields.certifiedNo4}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate4"
              name="certifiedDate4"
              value={fields.certifiedDate4}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo4Message" className="errorMessages">{messages.certifiedNo4.n}</p>
            <p id="certifiedDate4Message" className="errorMessages">{messages.certifiedDate4.n}</p>
            <Form.Check
              custom
              label="健康運動指導士"
              id="cert2Checks5"
              name="cert2Checks5"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[5] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo5"
              name="certifiedNo5"
              value={fields.certifiedNo5}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              name="certifiedDate5"
              id="certifiedDate5"
              value={fields.certifiedDate5}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo5Message" className="errorMessages">{messages.certifiedNo5.n}</p>
            <p id="certifiedDate5Message" className="errorMessages">{messages.certifiedDate5.n}</p>
            <Form.Check
              custom
              label="柔道整復師"
              id="cert2Checks6"
              name="cert2Checks6"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[6] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo6"
              name="certifiedNo6"
              value={fields.certifiedNo6}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate6"
              name="certifiedDate6"
              value={fields.certifiedDate6}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo6Message" className="errorMessages">{messages.certifiedNo6.n}</p>
            <p id="certifiedDate6Message" className="errorMessages">{messages.certifiedDate6.n}</p>
            <Form.Check
              custom
              label="鍼灸師"
              id="cert2Checks7"
              name="cert2Checks7"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[7] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo7"
              name="certifiedNo7"
              value={fields.certifiedNo7}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate7"
              name="certifiedDate7"
              value={fields.certifiedDate7}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo7Message" className="errorMessages">{messages.certifiedNo7.n}</p>
            <p id="certifiedDate7Message" className="errorMessages">{messages.certifiedDate7.n}</p>
            <Form.Check
              custom
              label="臨床検査技師"
              id="cert2Checks8"
              name="cert2Checks8"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[8] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo8"
              name="certifiedNo8"
              value={fields.certifiedNo8}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate8"
              name="certifiedDate8"
              value={fields.certifiedDate8}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo8Message" className="errorMessages">{messages.certifiedNo8.n}</p>
            <p id="certifiedDate8Message" className="errorMessages">{messages.certifiedDate8.n}</p>
            <Form.Check
              custom
              label="管理栄養士"
              id="cert2Checks9"
              name="cert2Checks9"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[9] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo9"
              name="certifiedNo9"
              value={fields.certifiedNo9}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate9"
              name="certifiedDate9"
              value={fields.certifiedDate9}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo9Message" className="errorMessages">{messages.certifiedNo9.n}</p>
            <p id="certifiedDate9Message" className="errorMessages">{messages.certifiedDate9.n}</p>
            <Form.Check
              custom
              label="研究・教育機関のスタッフ"
              id="cert2Checks10"
              name="cert2Checks10"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[10] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certifiedNo10"
              name="certifiedNo10"
              value={fields.certifiedNo10}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate10"
              name="certifiedDate10"
              value={fields.certifiedDate10}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certifiedNo10Message" className="errorMessages">{messages.certifiedNo10.n}</p>
            <p id="certifiedDate10Message" className="errorMessages">{messages.certifiedDate10.n}</p>
            <Form.Check
              custom
              label="大学院生・大学院修了者"
              id="cert2Checks11"
              name="cert2Checks11"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[11] }
              onChange={handleChecks}
            />
            <Form.Check
              custom
              label="その他"
              id="cert2Checks12"
              name="cert2Checks12"
              type="checkbox"
              value="1"
              checked={ 1 == cert2Checks[12] }
              onChange={handleChecks}
            />
            <Form.Control
              type="text"
              id="certified12Text"
              name="certified12Text"
              value={fields.certified12Text}
              onChange={handleFieldChange}
            />
            <Form.Control
              type="text"
              id="certifiedNo12"
              name="certifiedNo12"
              value={fields.certifiedNo12}
              onChange={handleFieldChange}
              placeholder="認定資格番号"
            />
            <Form.Control
              type="text"
              id="certifiedDate12"
              name="certifiedDate12"
              value={fields.certifiedDate12}
              onChange={handleFieldChange}
              placeholder="取得年月日"
            />
            <p id="certified12TextMessage" className="errorMessages">{messages.certified12Text.n}</p>
            <p id="certifiedNo12Message" className="errorMessages">{messages.certifiedNo12.n}</p>
            <p id="certifiedDate12Message" className="errorMessages">{messages.certifiedDate12.n}</p>
       */}
          </Form.Group>
          <p id="cert2ChecksMessage" className="errorMessages">{ cert2ChecksMessage }</p>
        </dd>
      </dl>
      <h3 className="">学位</h3>
      <dl className="">
        <dt>学位<span className="red">*</span></dt>
        <dd>
          <Form.Group className="inlineFormControl" controlId="degree" size="lg">
            <Form.Control
              type="text"
              name="degree"
              value={fields.degree}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="degreeMessage" className="errorMessages">{messages.degree.n}</p>
        </dd>
      </dl>
    </>

  );
}

export default CertificationInfo2FormV2;
